import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CallerContextComponent } from './caller-context.component';
import { CommonModule } from '@angular/common';
import { UXModule } from '../../shared/ux/ux.module';
import { UXPassengersModule } from '../../shared/ux-passengers/ux-passengers.module';
import { RouterModule } from '@angular/router';
import { CallerContextDropdownComponent } from './caller-context-dropdown/caller-context-dropdown.component';
import { PassengerLoyaltyIconComponent } from '../../shared/ux-passengers/passenger-loyalty-icon/passenger-loyalty-icon.component';

@NgModule({
  declarations: [CallerContextComponent, CallerContextDropdownComponent],
  imports: [CommonModule, UXModule, UXPassengersModule, RouterModule, PassengerLoyaltyIconComponent],
  exports: [CallerContextComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CallerContextModule {}
